import React from 'react';
import BaseInputComponent from './BaseInputComponent';
import { Input } from 'react-bootstrap';
import { getPwdError } from '../../helpers/common';
import { t } from '../../helpers/translate';
class PasswordComponent extends BaseInputComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      showConfirmPassword: false,
    };
  }

  handleKeyPress(event) {
    this.props.handleKeyPress && this.props.handleKeyPress(event);
  }

  render() {
    const placeHolder = this.props.placeholder ? this.props.placeholder : 'New Password';
    const showConfirmPassword = this.props.type !== 'login' && this.props.type !== 'reset';
    return this.props.editMode ? (
      <div className={this.props.pwdError ? 'has-error' : ''}>
        <div className='relative'>
          <Input
            type={this.state.showPassword ? 'text' : 'password'}
            ref='password'
            onKeyPress={this.handleKeyPress.bind(this)}
            autocomplete='none'
            onChange={(event) => {
              this.setPwd(event.target.value);
            }}
            placeholder={t(placeHolder)}
          >
            <i
              className='fa fa-eye showPasswordIcon'
              onClick={() => {
                this.setState({ showPassword: !this.state.showPassword });
              }}
            />
          </Input>
        </div>
        {showConfirmPassword && (
          <div className='relative'>
            <Input
              type={this.state.showConfirmPassword ? 'text' : 'password'}
              ref='confirm'
              onChange={(event) => {
                this.setPwd(event.target.value);
              }}
              placeholder='Re-enter Password'
            >
              <i
                className='fa fa-eye showPasswordIcon'
                onClick={() => {
                  this.setState({
                    showConfirmPassword: !this.state.showConfirmPassword,
                  });
                }}
              />
            </Input>
          </div>
        )}

        <span>{this.props.pwdError}</span>
      </div>
    ) : (
      <div>
        <span>*******</span>
      </div>
    );
  }

  setPwd(value) {
    this.handleChange(value);
    return this.props.checkPwdError(
      getPwdError(
        this.refs.password.refs.input.value,
        this.refs.confirm.refs.input.value
      )
    );
  }
}

export default PasswordComponent;



// WEBPACK FOOTER //
// ./src/components/common/PasswordComponent.js